
import { Vue, Component } from 'vue-property-decorator'
import {BoListPanel} from "bonomo";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {namespace} from "vuex-class";
import {ILockerCompany} from "@/model/LockerCompany/lockerCompanyInterface";
import LockerCompanyLogs from "@/components/lockerCompany/modules/LockerCompanyLogs.vue";
import LCCreateLockerCompanyDialog from "@/components/lockerCompany/modules/LCCreateLockerCompanyDialog.vue";
import ImageUploader from "@/components/shared/ImageUploader.vue";
import {IOnOffHandlers} from "bonomo/dist";
import CreateButton from "@/components/shared/CreateButton.vue";

const lockerCompanyModule = namespace("lockerCompanyModule");

// should be... CompanyList !
@Component({
  components: {
    BoListPanel,
    CreateButton,
    ImageUploader,
    LCCreateLockerCompanyDialog,
    LockerCompanyLogs,
  }
})
export default class LockerCompaniesList extends Vue {
  @lockerCompanyModule.Action('fetchLockerCompanies')
  fetchLockerCompanies!: (filters: any) => void;

  @lockerCompanyModule.Getter('lockerCompanies')
  lockerCompanies!: ILockerCompany[]

  showCreateDialog: boolean = false;
  showUploadDialog: boolean = false;
  showUploadItem: ILockerCompany = {} as ILockerCompany;

  get headers(): BetterDataTableHeader[] {
    return  [
      { text: this.$t('common.id'), align: 'start', sortable: true, value: 'id' },
      { text: this.$t('lockerCompanies.fields.image'), align: 'start', sortable: true, value: 'image_url' },
      { text: this.$t('lockerCompanies.fields.description'), align: 'start', sortable: true, value: 'description' },
      { text: this.$t('common.slug'), align: 'start', sortable: true, value: 'slug' },
    ];
  }

  get imageUploadEndpoint(): string {
    return "lockerCompanies/" + this.showUploadItem.id + "/image";
  }

  onCreateButton() {
    this.showCreateDialog = true;
  }

  onImageChanged() {
    this.showUploadDialog = false;
    this.fetchLockerCompanies({});
  }

  onImageClick(lockerCompany: ILockerCompany) {
    this.showUploadItem = lockerCompany;
    this.showUploadDialog = true;
  }

}

